import {useCallback, useEffect, useState} from "react";
import {getLessonsTags} from "api/services/lesson-service";
import {LessonsTags} from "models/LessonsTags";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useGetTags = () => {
    const [tags, setTags] = useState<LessonsTags>();
    const {callAPI, loading} = useWorkspaceApiCall(getLessonsTags, '', 'getTags.error');

    const fetchTags = useCallback(async () => {
        const resp = await callAPI({});

        if (resp?.success && resp.data) {
            setTags(resp.data);
        }

        return resp;
    }, [callAPI]);

    useEffect(() => {
        fetchTags();
    }, [fetchTags]);

    return {tags, fetchTags, isLoading: loading};
}
